import { GenericLazyString } from '@eventbrite/i18n';
import interpolate from '@eventbrite/interpolate-lazy-string';
import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import { TicketStatus } from '../../../models/tickets';
import { TICKET_STATUS_MAP } from '../constants';

export type TicketSalesStatusSummaryProps = {
    className?: Parameters<typeof classNames>[0];
} & (
    | {
          ticketStatus: Exclude<
              TicketStatus,
              TicketStatus.salesNotStarted | TicketStatus.salesStartSoon
          >;
          formattedSalesStartDate?: undefined;
      }
    | {
          ticketStatus:
              | TicketStatus.salesNotStarted
              | TicketStatus.salesStartSoon;
          formattedSalesStartDate: GenericLazyString | string;
      }
);

const displayTextByTicketStatus: Record<
    TicketStatus,
    GenericLazyString | null
> = {
    [TicketStatus.onSale]: null,
    [TicketStatus.salesEndSoon]: null,
    [TicketStatus.salesEnded]:
        TICKET_STATUS_MAP[TicketStatus.salesEnded].displayText,
    [TicketStatus.salesNotStarted]:
        TICKET_STATUS_MAP[TicketStatus.salesNotStarted].displayText,
    [TicketStatus.salesStartAfter]:
        TICKET_STATUS_MAP[TicketStatus.salesStartAfter].displayText,
    [TicketStatus.salesStartSoon]:
        TICKET_STATUS_MAP[TicketStatus.salesStartSoon].displayText,
    [TicketStatus.soldOut]: null,
    [TicketStatus.unavailable]:
        TICKET_STATUS_MAP[TicketStatus.unavailable].displayText,
};

const TicketSalesStatusSummary: FunctionComponent<
    TicketSalesStatusSummaryProps
> = ({ formattedSalesStartDate, ticketStatus, className }) => {
    const displayText = displayTextByTicketStatus[ticketStatus];

    return displayText ? (
        <span
            className={classNames(
                'eds-text-bm eds-text-color--ui-600',
                className,
            )}
            data-testid="ticket-sales-status-summary"
        >
            {interpolate(displayText, { date: formattedSalesStartDate }, true)}
        </span>
    ) : null;
};
export default TicketSalesStatusSummary;
